<template >
  <div class="h-full relative p-0 pointer-events-none">
    <div class="h-full flex flex-col justify-between fixed z-50 w-full">
      <div class="z-10">
        <div class="hover-container" @mousemove="updateCursorPosition">
          <p
            class="cursor-pointer sm:text-[110px] md:text-[130px] px-5 shadow-text pointer-events-auto sm:leading-[110px] pt-5 hover-text underline-text"
            @click="infoShow"
            @mouseenter="show = true"
            @mouseleave="show = false"
          >
            Núria
            <br class="md:hidden" />
            Jordán
          </p>
          <div
            v-if="show"
            :style="{ top: cursorY + 'px', left: cursorX + 'px' }"
            class="hover-image"
          >
            <div>
              <img :src="imageSrc" alt="" class="relative" />
              <p class="absolute top-0 left-4"></p>
            </div>
          </div>
        </div>
        <p class="px-7 text-2xl shadow-text py-3">
          {{ $t("dedicacio") }}
        </p>
      </div>
      <div class="z-10 flex justify-between w-full items-center">
        <div>
          <p
            class="cursor-pointer text-[50px] p-5 shadow-text pointer-events-auto hover:underline"
            @click="infoProjects"
          >
            {{ $t("projects") }}
          </p>
        </div>
        <div
          v-if="scrollVisible"
          class="animation-scroll justify-items-center sm:hidden md:block"
        >
          <p>Scroll</p>
          <svg
            width="45"
            height="19"
            viewBox="0 0 79 19"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <line
              x1="0.385994"
              y1="1.0775"
              x2="41.0149"
              y2="18.0775"
              stroke="var(--text-color)"
              stroke-width="2"
            />
            <line
              x1="40.223"
              y1="18.0861"
              x2="78.4997"
              y2="1.08608"
              stroke="var(--text-color)"
              stroke-width="2"
            />
          </svg>
        </div>
        <div>
          <selector-idiomes class="pointer-events-auto"></selector-idiomes>
        </div>
      </div>
    </div>
    <div class="sm:hidden md:block">
      <horizontal-scroll
        class="absolute top-0 left-0 w-full pointer-events-auto"
        @word-clicked="handleWordClick"
        :isVisible="isVisible"
        :projectsVisible="projectsVisible"
      ></horizontal-scroll>
    </div>
    <div
      v-if="isVisible"
      class="fixed h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-50 pointer-events-auto"
    >
      <div class="sm:w-full md:w-1/2 shadow-2xl background-variable h-full">
        <div class="flex justify-between px-7 md:px-12 mt-4">
          <p class="text-6xl">NJ</p>
          <div @click="infoShow" class="flex justify-end cursor-pointer">
            <Icon icon="iwwa:close" width="55px" weight="light" />
          </div>
        </div>

        <about-copia></about-copia>
      </div>
      <div
        class="sm:hidden md:w-1/2 md:block opacity-50 background-variable"
      ></div>
    </div>
    <div
      v-if="projectsVisible"
      class="fixed h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-50 pointer-events-auto"
    >
      <div class="w-full md:w-1/2 md:shadow-2xl background-variable h-full">
        <div class="flex justify-between mx-7 md:mx-12 mt-4">
          <p :class="['text-6xl', projectsVisible ? 'invisible' : '']">NJ</p>
          <div @click="infoProjects" class="flex justify-end cursor-pointer">
            <Icon icon="iwwa:close" width="55px" weight="light" />
          </div>
        </div>
        <div class="flex flex-col pt-12 px-8">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="md:flex items-end gap-2"
            @mouseover="showImage(index)"
            @mouseleave="hideImage"
          >
            <router-link :to="item.url">
              <p class="text-3xl hover:underline">
                {{ item.title }}
              </p></router-link
            >
            <p class="text-xl text-gray-400 pb-3 md:pb-0">
              {{ $t(item.subtitle) }}
            </p>
          </div>
        </div>
      </div>
      <div class="hidden md:block h-full w-1/2">
        <div v-if="hoveredIndex !== null" class="h-full">
          <img
            :src="getImageUrl(hoveredIndex)"
            alt="Hovered Image"
            class="h-full w-full object-cover"
          />
        </div>
        <div v-else class="opacity-50 h-full w-full background-variable"></div>
      </div>
    </div>
  </div>
</template>

<script>
import AboutCopia from "@/components/AboutCopia.vue";
import HorizontalScroll from "./HorizontalScroll.vue";
import SelectorIdiomes from "./SelectorIdiomes.vue";

export default {
  components: {
    AboutCopia,
    HorizontalScroll,
    SelectorIdiomes,
  },
  data() {
    return {
      isVisible: false,
      projectsVisible: false,
      show: false,
      cursorX: 0,
      cursorY: 0,
      imageSrc: "/img/NuriaJordanSanchez.jpg",
      scrollVisible: true,
      hasScrolled: false,
      items: [
        {
          title: "L'anòmala",
          subtitle: "developerInteractive",
          url: "/anomala",
        },
        {
          title: "El Modern",
          subtitle: "developerInteractive",
          url: "/modern",
        },
        {
          title: "Wildtech",
          subtitle: "webDeveloper2",
          url: "/wildtech",
        },
        {
          title: "Sense",
          subtitle: "webDeveloper2",
          url: "/sense",
        },
        {
          title: "Broomx",
          subtitle: "webDeveloper2",
          url: "/broomx",
        },
        {
          title: "Units x Educar",
          subtitle: "webDeveloper2",
          url: "/units",
        },
      ],
      images: [
        "/img/anomala/anomala1.png",
        "/img/modern/modern1.png",
        "/img/wildtech/wildtechmenu2.png",
        "/img/sense/sensemenu.png",
        "/img/broomx/broomxmenu.png",
        "/img/units/unitsmenu.jpg",
      ],
      hoveredIndex: null,
    };
  },
  methods: {
    infoShow() {
      this.isVisible = !this.isVisible;
    },
    infoProjects() {
      this.projectsVisible = !this.projectsVisible;
      console.log(this.projectsVisible);
    },
    showImage(index) {
      this.hoveredIndex = index;
    },
    hideImage() {
      this.hoveredIndex = null;
    },
    getImageUrl(index) {
      return this.images[index];
    },
    handleWordClick(word) {
      if (word === "projectes") {
        this.projectsVisible = !this.projectsVisible;
        console.log(
          "Evento recibido: Se hizo clic en 'projectes'",
          this.projectsVisible
        );
      } else if (word === "mi") {
        this.isVisible = !this.isVisible;
        console.log("Evento recibido: Se hizo clic en 'mi'", this.isVisible);
      }
    },
    handleScroll() {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      if (scrollTop > 0) {
        this.hasScrolled = true; // Marca que el usuario ha hecho scroll
      }
      this.scrollVisible = !this.hasScrolled; // Si ya ha hecho scroll, no lo vuelve a mostrar
    },
    updateCursorPosition(event) {
      this.cursorX = event.clientX; // Ajuste para desplazar la imagen un poco
      this.cursorY = event.clientY;
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style>
.hiddenObject {
  display: none;
}

.background-variable {
  background-color: var(--background-color);
}

.shadow-text {
  text-shadow: -0.5px -0.5px 0 var(--background-color),
    0.5px -0.5px 0 var(--background-color),
    -0.5px 0.5px 0 var(--background-color),
    0.5px 0.5px 0 var(--background-color);
}

.hover-container {
  position: relative;
}

.hover-text {
  font-size: 1.5rem;
  cursor: pointer;
  width: max-content;
}

.hover-image {
  position: absolute;
  width: 200px;
  height: auto;
  pointer-events: none;
}

.hover-image img {
  border-radius: 15px;
}

.underline-text {
  position: relative;
}

.underline-text::after {
  content: "";
  position: absolute;
  left: 20px;
  bottom: -5px;
  width: 95%;
  height: 5px;
  background-color: var(--text-color);
  transform: scaleY(0);
  transform-origin: top;
}

.underline-text:hover::after {
  transform: scaleY(0.8);
}

.animation-scroll {
  animation-duration: 3s;
  animation-name: animation-scroll;
  animation-iteration-count: infinite;
}

@keyframes animation-scroll {
  100% {
    opacity: 100%;
  }

  50% {
    opacity: 10%;
  }

  0% {
    opacity: 100%;
  }
}
</style>